<template lang="pug">
form
  .row
    .col-md-8
      p - Các bài chia sẻ (icon thành tích, lý thuyết, video) của user về trang của mình.
      p - Các bài chia sẻ của friend và bạn đồng hành.
      p - Kết quả cuộc thi chung thuộc môn học thế mạnh của user.
      p - Các bài chia sẻ của người mà user đã chọn đang theo dõi.
</template>
<script>
export default {
  props: {
    user: Object
  }
}
</script>



// WEBPACK FOOTER //
// Activity.vue?d7cb847a